// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupByDateItems__title-f0e481 {
  margin-inline-start: var(--padding);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-70);
}

.GroupByDateItems__title-f0e481:not(:first-of-type) {
  margin-top: 10px;
}

.GroupByDateItems__list-b11f0b {
  list-style-type: none;
  margin: 0;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/main/SharedData/components/GroupByDateItems/styles.m.css"],"names":[],"mappings":"AAAA;EACE,mCAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,qBAAA;EACA,SAAA;EACA,UAAA;AACF","sourcesContent":[".title {\n  margin-inline-start: var(--padding);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-70);\n}\n\n.title:not(:first-of-type) {\n  margin-top: 10px;\n}\n\n.list {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `GroupByDateItems__title-f0e481`,
	"list": `GroupByDateItems__list-b11f0b`
};
module.exports = ___CSS_LOADER_EXPORT___;
